import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Pages
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Rentals from "./pages/Rentals";
import RentalsOperator from "./pages/RentalsOperator";
import NewRental from "./pages/NewRental";
import Customers from "./pages/Customers";
import Bikes from "./pages/Bikes";
import BikesOperator from "./pages/BikesOperator";
import Plans from "./pages/Plans";
import PlansOperator from "./pages/PlansOperator";
import Branches from "./pages/Branches";
import Users from "./pages/Users";
import ProfilePage from "./pages/Profile";
import NotFound from "./pages/NotFound";
import Shifts from "./pages/Shifts";
import Payments from "./pages/Payments";
import Inventory from "./pages/Inventory";
import RegistroClientePage from "./pages/RegistroClientePage";
import ForgotPassword from "./pages/ForgotPassword";
import UpdatePassword from "./pages/UpdatePassword";
import ReportsPage from "./pages/Reports";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/update-password" element={<UpdatePassword />} />
              <Route path="/register" element={<RegistroClientePage />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/rentals" element={
                <ProtectedRoute requiredRoles={['super_admin','branch_admin']}>
                  <Rentals />
                </ProtectedRoute>
              } />
              <Route path="/rentals-operator" element={
                <ProtectedRoute requiredRoles={['operator']}>
                  <RentalsOperator />
                </ProtectedRoute>
              } />
              <Route path="/new-rental" element={
                <ProtectedRoute>
                  <NewRental />
                </ProtectedRoute>
              } />
              <Route path="/customers" element={
                <ProtectedRoute>
                  <Customers />
                </ProtectedRoute>
              } />
              <Route path="/bikes" element={
                <ProtectedRoute requiredRoles={['super_admin','branch_admin']}>
                  <Bikes />
                </ProtectedRoute>
              } />
              <Route path="/bikes-operator" element={
                <ProtectedRoute requiredRoles={['operator']}>
                  <BikesOperator />
                </ProtectedRoute>
              } />
              <Route path="/plans" element={
                <ProtectedRoute requiredRoles={['super_admin','branch_admin']}>
                  <Plans />
                </ProtectedRoute>
              } />
              <Route path="/plans-operator" element={
                <ProtectedRoute requiredRoles={['operator']}>
                  <PlansOperator />
                </ProtectedRoute>
              } />
              <Route path="/branches" element={
                <ProtectedRoute requiredRoles={['super_admin']}>
                  <Branches />
                </ProtectedRoute>
              } />
              <Route path="/shifts" element={
                <ProtectedRoute>
                  <Shifts />
                </ProtectedRoute>
              } />
              <Route path="/payments" element={
                <ProtectedRoute requiredRoles={['super_admin','branch_admin']}>
                  <Payments />
                </ProtectedRoute>
              } />
              <Route path="inventory" element={
                <ProtectedRoute>
                  <Inventory />
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute requiredRoles={['super_admin']}>
                  <Users />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="/reports" element={
                <ProtectedRoute>
                  <ReportsPage />
                </ProtectedRoute>
              } />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
